// import React from "react";
// import Logo from "../../components/common/Logo";
// import { ArrowLeft } from "lucide-react";

// function DemoSession() {
//     return (
//         <>

//                 <div className="min-h-screen bg-[#F4EFE8] px-4 md:px-10 py-6">      {/* LOGO */}
//                     <div className="mb-8">
//                         <Logo />
//                     </div>

//                     {/* TOP BAR */}
//                     <div className="bg-primary rounded-md h-[70px] flex items-center justify-between px-6 md:px-8">

//                         <h2 className="text-white text-[24px] md:text-[40px] font-semibold">
//                             Sample Session Class
//                         </h2>

//                         <button>
//                             <ArrowLeft
//                                 size={40}
//                                 className="text-white"
//                             />
//                         </button>

//                     </div>
//                 </div>
//         </>
//     )
// }
// export default DemoSession;


import React, { useRef, useState } from "react";
import { ArrowLeft, Play, Maximize } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

function DemoSession() {
    const navigate = useNavigate();
    const videoRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(51);
    const [duration, setDuration] = useState(151);

    // Play / Pause
    const toggleVideo = async () => {
        if (!videoRef.current) return;

        try {
            if (videoRef.current.paused) {
                await videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        } catch (error) {
            console.log("Video playback error:", error);
        }
    };

    // Video time
    const handleTimeUpdate = () => {
        if (!videoRef.current) return;

        setCurrentTime(videoRef.current.currentTime);
    };

    // Video duration
    const handleLoadedMetadata = () => {
        if (!videoRef.current) return;

        if (Number.isFinite(videoRef.current.duration)) {
            setDuration(videoRef.current.duration);
        }
    };

    // Format time
    const formatTime = (time) => {
        if (!Number.isFinite(time)) return "0:00";

        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);

        return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    };

    // Progress
    const progress =
        duration > 0
            ? Math.min((currentTime / duration) * 100, 100)
            : 0;

    // Fullscreen
    const handleFullscreen = () => {
        if (!videoRef.current) return;

        if (videoRef.current.requestFullscreen) {
            videoRef.current.requestFullscreen();
        }
    };

    return (
        <div className="min-h-screen min-h-[100dvh] bg-[#F7F3EA] text-[#17144B] overflow-x-hidden">

            {/* =====================================================
          MAIN CONTAINER
      ====================================================== */}

            <div className="w-full px-4 sm:px-6 lg:px-8 py-5 sm:py-6">

                {/* =====================================================
            HEADER
        ====================================================== */}

                <header className="w-full mb-5 sm:mb-6">

                    <Link
                        to="/"
                        className="inline-flex flex-col items-start"
                    >

                        {/* Logo */}
                        <div className="text-[24px] sm:text-[27px] lg:text-[29px] leading-none font-extrabold tracking-[-1.2px] whitespace-nowrap">

                            <span className="text-[#17144B]">
                                Insta
                            </span>

                            <span className="text-[#C95737]">
                                ED
                            </span>

                            <span className="text-[#17144B]">
                                {" "}Tuitions
                            </span>

                        </div>

                        {/* Subtitle */}
                        <div className="mt-1.5 text-[9px] sm:text-[10px] lg:text-[11px] tracking-[0.15em] text-[#8C84A0] uppercase whitespace-nowrap">
                            ONLINE TUITIONS · CLASSES 6–10
                        </div>

                    </Link>

                </header>


                {/* =====================================================
            TOP PURPLE BAR
        ====================================================== */}

                <div
                    className="
            w-full
            min-h-[58px]
            sm:min-h-[64px]
            lg:min-h-[70px]
            bg-[#4035C9]
            rounded-[14px]
            sm:rounded-[16px]
            flex
            items-center
            justify-between
            gap-4
            px-5
            sm:px-7
            lg:px-8
          "
                >

                    <h1
                        className="
              text-white
              text-[18px]
              sm:text-[21px]
              lg:text-[23px]
              font-bold
              leading-tight
            "
                    >
                        Sample session class
                    </h1>


                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        aria-label="Go back"
                        className="
              shrink-0
              w-9
              h-9
              sm:w-10
              sm:h-10
              flex
              items-center
              justify-center
              rounded-full
              text-white
              hover:bg-white/10
              transition-colors
            "
                    >
                        <ArrowLeft
                            size={20}
                            strokeWidth={2}
                        />
                    </button>

                </div>


                {/* =====================================================
            VIDEO SECTION
        ====================================================== */}

                <main className="w-full max-w-[900px] mx-auto mt-5 sm:mt-6 lg:mt-7">

                    {/* Video Card */}

                    <div
                        className="
              w-full
              rounded-[14px]
              sm:rounded-[16px]
              overflow-hidden
              border
              border-[#DED4C1]
              bg-[#F0EBDD]
            "
                    >

                        {/* =================================================
                VIDEO AREA
            ================================================== */}

                        <div
                            className="
                relative
                w-full
                aspect-video
                bg-[#F0EBDD]
              "
                        >

                            {/* Video information */}

                            <div
                                className="
                  absolute
                  top-5
                  left-5
                  sm:top-6
                  sm:left-7
                  z-10
                  text-[#4035C9]
                  text-[11px]
                  sm:text-[12px]
                  font-medium
                  pointer-events-none
                "
                            >
                                Class 9 Maths · Polynomials · 2:31
                            </div>


                            <video
                                ref={videoRef}
                                playsInline
                                preload="metadata"
                                onPlay={() => setIsPlaying(true)}
                                onPause={() => setIsPlaying(false)}
                                onEnded={() => setIsPlaying(false)}
                                onTimeUpdate={handleTimeUpdate}
                                onLoadedMetadata={handleLoadedMetadata}
                                className="
                  absolute
                  inset-0
                  w-full
                  h-full
                  object-cover
                  bg-[#F0EBDD]
                "
                            >
                                <source
                                    src="https://www.w3schools.com/html/mov_bbb.mp4"
                                    type="video/mp4"
                                />

                                Your browser does not support the video tag.
                            </video>


                            {/* =================================================
                  CENTER PLAY BUTTON
              ================================================== */}

                            {!isPlaying && (
                                <button
                                    type="button"
                                    onClick={toggleVideo}
                                    aria-label="Play sample session"
                                    className="
                    absolute
                    left-1/2
                    top-1/2
                    -translate-x-1/2
                    -translate-y-1/2
                    z-20
                    w-[58px]
                    h-[58px]
                    sm:w-[64px]
                    sm:h-[64px]
                    rounded-full
                    bg-[#CB4B2D]
                    flex
                    items-center
                    justify-center
                    shadow-[0_8px_20px_rgba(203,75,45,0.25)]
                    hover:scale-105
                    transition-transform
                  "
                                >
                                    <Play
                                        size={25}
                                        fill="white"
                                        strokeWidth={0}
                                        className="ml-1 text-white"
                                    />
                                </button>
                            )}

                        </div>


                        {/* =================================================
                VIDEO CONTROL BAR
            ================================================== */}

                        <div
                            className="
                h-[42px]
                sm:h-[44px]
                bg-[#5B587D]
                flex
                items-center
                gap-3
                sm:gap-4
                px-4
                sm:px-5
              "
                        >

                            {/* Play / Pause */}

                            <button
                                type="button"
                                onClick={toggleVideo}
                                aria-label="Play or pause"
                                className="
                  text-white
                  shrink-0
                  flex
                  items-center
                  justify-center
                "
                            >

                                {isPlaying ? (
                                    <span className="flex gap-[3px]">
                                        <span className="block w-[3px] h-[14px] bg-white rounded-sm" />
                                        <span className="block w-[3px] h-[14px] bg-white rounded-sm" />
                                    </span>
                                ) : (
                                    <Play
                                        size={15}
                                        fill="white"
                                        strokeWidth={0}
                                    />
                                )}

                            </button>


                            {/* Current Time */}

                            <span className="text-white text-[10px] sm:text-[11px] font-medium whitespace-nowrap">
                                {formatTime(currentTime)}
                            </span>


                            {/* Progress */}

                            <div className="flex-1 h-[4px] rounded-full bg-white/30 overflow-hidden">

                                <div
                                    className="h-full bg-white rounded-full"
                                    style={{
                                        width: `${progress}%`,
                                    }}
                                />

                            </div>


                            {/* Duration */}

                            <span className="text-white text-[10px] sm:text-[11px] font-medium whitespace-nowrap">
                                {formatTime(duration)}
                            </span>


                            {/* Fullscreen */}

                            <button
                                type="button"
                                onClick={handleFullscreen}
                                aria-label="Fullscreen"
                                className="
                  text-white
                  shrink-0
                  hover:opacity-80
                  transition-opacity
                "
                            >
                                <Maximize
                                    size={14}
                                    strokeWidth={2}
                                />
                            </button>

                        </div>

                    </div>


                    {/* =====================================================
              ACTION BUTTONS
          ====================================================== */}

                    <div
                        className="
              flex
              flex-col
              sm:flex-row
              items-center
              justify-center
              gap-3
              sm:gap-4
              mt-5
              sm:mt-6
            "
                    >

                        {/* Get Started */}

                        <Link
                            to="/signup"
                            className="
                w-full
                sm:w-auto
                min-w-[118px]
                h-[40px]
                px-5
                rounded-full
                bg-[#CB4B2D]
                text-white
                text-[13px]
                font-semibold
                flex
                items-center
                justify-center
                hover:bg-[#b94429]
                transition-colors
              "
                        >
                            Get started
                        </Link>


                        {/* Buy Subscription */}

                        <Link
                            to="/subscription"
                            className="
                w-full
                sm:w-auto
                min-w-[160px]
                h-[40px]
                px-5
                rounded-full
                bg-white
                border
                border-[#DED4C1]
                text-[#17144B]
                text-[13px]
                font-medium
                flex
                items-center
                justify-center
                hover:bg-[#FCFAF5]
                transition-colors
              "
                        >
                            Buy a subscription
                        </Link>

                    </div>

                </main>


                {/* =====================================================
            FOOTER
        ====================================================== */}

                <footer
                    className="
            border-t
            border-[#E6DDCE]
            mt-20
            sm:mt-24
            lg:mt-28
            pt-6
            pb-4
          "
                >

                    <div
                        className="
              flex
              flex-wrap
              items-center
              justify-center
              gap-x-5
              gap-y-2
              text-[11px]
              sm:text-[13px]
            "
                    >

                        <Link
                            to="/terms-condition"
                            className="text-[#4035C9] hover:underline"
                        >
                            Terms of use
                        </Link>

                        <Link
                            to="/policy"
                            className="text-[#4035C9] hover:underline"
                        >
                            Privacy policy
                        </Link>

                        <span className="text-[#8C84A0]">
                            © 2026
                        </span>

                    </div>

                </footer>

            </div>
        </div>
    );
}

export default DemoSession;